<template>
    <div class="hot_div">
    <!-- <Hezuo></Hezuo> -->
        <div class="hot_list">
            <div class="flex_between div_title">
                <h4 class="title">基本信息</h4>
                <div class="flex_center title_right">
                    <span class="del" v-if="state" @click="state = !state">取消</span>
                    <button class="flex_center " @click="state = !state" v-if="!state">
                        <span>修改</span>
                    </button>
                    <button class="flex_center state" @click="saveUser" v-else>
                        <span>保存</span>
                    </button>
                </div>
            </div>
            <div class="user_div" v-if="!state">
                <div class="user_li flex_center">
                    <span class="li_title">登录名：</span>
                    <div class="li_text">{{user.mobile}}</div>
                </div>
                <div class="user_li flex_center">
                    <span class="li_title">昵称：</span>
                    <div class="li_text"> {{user.username}}</div>
                </div>
                <div class="user_li flex_center">
                    <span class="li_title">邮箱：</span>
                    <div class="li_text"> {{user.email}}</div>
                </div>
                <div class="user_li flex_center">
                    <span class="li_title">真实姓名：</span>
                    <div class="li_text">{{user.realname}}</div>
                </div>
                <div class="user_li flex_center radio_li">
                    <span class="li_title">性别：</span>
                    <div class="li_text flex_start">
                        <span v-if="user.sex == 0">保密</span>
                        <span v-else-if="user.sex == 1">男</span>
                        <span v-else>女</span>
                    </div>
                </div>
                <div class="user_li flex_center">
                    <span class="li_title">生日：</span>
                    <div class="li_text">{{user.birth}}</div>
                </div>
                <div class="user_li flex_center">
                    <span class="li_title">工作单位：</span>
                    <div class="li_text">{{user.company}}</div>
                </div>
                <div class="user_li flex_center">
                    <span class="li_title">职称：</span>
                    <div class="li_text">{{user.professor}}</div>
                </div>
                <div class="user_li flex_center">
                    <span class="li_title">科室：</span>
                    <div class="li_text">{{user.office}}</div>
                </div>
                <div class="user_li flex_center" style="margin-top:0">
                    <span class="li_title">执医证：</span>
                    <div class="li_text">
                        <img style="width:150px;height:150px" @click="bigImg(user.cert)"
                        :src="user.cert"
                        alt=""
                        >
                    </div>
                </div>
                <div class="user_li flex_center">
                    <span class="li_title">邮寄地址：</span>
                    <div class="li_text">{{user.address}}</div>
                </div>
                <div class="user_li flex_center">
                    <span class="li_title">会员邀请码：</span>
                    <div class="li_text">{{user.code}}</div>
                </div>
            </div>
            <!-- 修改数据 -->
            <div class="from_div user_div" v-if="state">
                <div class="user_li flex_center">
                    <span class="li_title">登录名：</span>
                    <div class="li_text">{{user.mobile}}</div>
                </div>
                <div class="user_li flex_center">
                    <span class="li_title">昵称：</span>
                    <div class="li_text">
                        <el-col :span="14">
                            <el-input v-model="username" placeholder="请输入内容"></el-input>
                        </el-col>
                    </div>
                </div>
                <div class="user_li flex_center">
                    <span class="li_title">邮箱：</span>
                    <div class="li_text">
                        <el-col :span="14">
                            <el-input v-model="email" placeholder="请输入内容"></el-input>
                        </el-col>
                    </div>
                </div>
                <div class="user_li flex_center">
                    <span class="li_title">真实姓名：</span>
                    <div class="li_text flex_between">
                        <el-col :span="14">
                            <el-input v-model="realname" placeholder="请输入内容"></el-input>
                        </el-col>
                        <el-select v-model="power_see.realname" placeholder="请选择">
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="user_li flex_center radio_li">
                    <span class="li_title">性别：</span>
                    <div class="li_text flex_start">

                        <el-radio-group v-model="sex">
                            <el-radio label="0">保密</el-radio>
                            <el-radio label="1">男</el-radio>
                            <el-radio label="2">女</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="user_li flex_center radio_li ">
                    <span class="li_title">生日：</span>
                    <div class="li_text flex_between">
                        <el-date-picker v-model="birth" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                            placeholder="选择日期">
                        </el-date-picker>
                        <el-select v-model="power_see.birth" placeholder="请选择">
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="user_li flex_center">
                    <span class="li_title">工作单位：</span>
                    <div class="li_text flex_between">
                        <el-col :span="14">
                            <el-input v-model="company" placeholder="请输入内容"></el-input>
                        </el-col>
                        <el-select v-model="power_see.cpmpany" placeholder="请选择">
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="user_li flex_center">
                    <span class="li_title">职称：</span>
                    <div class="li_text flex_between">
                        <el-col :span="14">
                            <el-input v-model="professor" placeholder="请输入内容"></el-input>
                        </el-col>
                        <el-select v-model="power_see.professor" placeholder="请选择">
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="user_li flex_center">
                    <span class="li_title">科室：</span>
                    <div class="li_text flex_between">
                        <el-col :span="14">
                            <el-input v-model="office" placeholder="请输入内容"></el-input>
                        </el-col>
                        <el-select v-model="power_see.office" placeholder="请选择">
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="user_li flex_start">
                    <span class="li_title">执医证：</span>
                        <el-upload
                                class="avatar-uploader"
                                :action="URL + 'upload'"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                :before-upload="handleAvatarPreview">
                                <img v-if="cert" :src="cert" style="width:150px;height:150px">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </div>
                <div class="user_li flex_center">
                    <span class="li_title">邮寄地址：</span>
                    <div class="li_text">
                        <el-col :span="14">
                            <el-input v-model="address" placeholder="请输入内容"></el-input>
                        </el-col>
                    </div>
                </div>
                <div class="user_li flex_center">
                    <span class="li_title">会员邀请码：</span>
                    <div class="li_text">
                        <el-col :span="14">
                            <el-input v-model="invite" placeholder="请输入邀请码"></el-input>
                        </el-col>
                    </div>
                </div>
            </div>
        </div>
        <div id="overlay" style="display:none;" @click="closebig"></div>
    </div>
</template>

<script>
import Hezuo from '@/components/tool/hezuo.vue'

    export default {
        name: 'popup',
        components:{Hezuo},
        data() {
            return {
                state: false,//管理状态
                user: {},//用户信息      
                URL: this.$URL,
                username: '',//昵称
                realname: '',//真实姓名
                sex: '0',//0保密 1男 2女
                birth: '',//生日
                company: '',//工作单位
                professor: '',//职称
                office: '',//科室
                power_see: {},//可见
                invite: '',//会员邀请码
                email:'',//邮箱
                cert:'',
                address:'',//邮寄地址
                options: [{
                    value: '0',
                    label: '仅自己可见'
                }, {
                    value: '1',
                    label: '所有人可见'
                }, {
                    value: '2',
                    label: '我关注的人可见'
                }],
            }
        },
        props: {

        },
        watch: {

        },
        methods: {
            closebig(){
                overlay.style.display = 'none';
            },
            bigImg(img){
                var overlay = document.getElementById('overlay');
                overlay.style.display = 'flex';
                overlay.innerHTML = '<img src="' + img + '" alt="Large image" style="max-width:40%">';
            },
            handleAvatarPreview () {//开始上传
                layer.open({
                    type: 2
                    , content: '上传中'
                });
                },
                handleAvatarSuccess (res, file) {
                layer.closeAll();
                layer.open({
                    content: "上传完成",
                    time: true,
                    skin: "msg"
                });
                this.cert = res.data;
                },
            saveUser() {//保存修改

                let that = this;
                for (var key in this.power_see) {
                    this.options.forEach(element => {
                        if (element.value == this.power_see[key] || element.label == this.power_see[key]) {
                            that.power_see[key] = element.value;
                        }
                    })
                }

                this.$post('user_modify', {
                    member_id: this.user.id,
                    sex: this.sex,
                    username: this.username,
                    realname: this.realname,
                    birth: this.birth,
                    company: this.company,
                    professor: this.professor,
                    office: this.office,
                    cert:this.cert,
                    power_see: JSON.stringify(this.power_see),
                    invite: this.invite,
                    email: this.email,
                    address: this.address,
                }).then(res => {
                    layer.open({
                        content: '修改成功'
                        , time: 1
                        , skin: 'msg'
                    });
                    that.user = res.data;
                    that.getUser();
                    setTimeout(() => {
                        that.state = false;
                    }, 1000)
                }).catch(res => {
                     
                    layer.open({
                        content: res.message
                        , time: 2
                        , skin: 'msg'
                    });
                })
            },
            geHome: function () {
                this.$router.replace('/');
            },
            getUser() {
                let that = this;
                this.REFRESH_USER();
            },
            assignment() {//赋值
                this.username = this.user.username;
                this.realname = this.user.realname;
                this.sex = this.user.sex.toString();
                this.birth = this.user.birth;
                this.company = this.user.company;
                this.professor = this.user.professor;
                this.office = this.user.office;
                this.invite = this.user.code;
                this.email = this.user.email;
                this.cert = this.user.cert
                this.pictureUrlList = [ this.user.cert]
                this.address = this.user.address;
                if (this.user.power_see) {
                    this.power_see = JSON.parse(this.user.power_see);
                    for (var key in this.power_see) {
                        this.power_see[key] = this.options[this.power_see[key]].label;
                    }
                }

            },
        },
        mounted() {
            this.getUser();
            this.user = this.USER();
            this.assignment();
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .el-col input,
    .el-select input,
    .el-input__inner {
        outline: 1px solid #DFDFDF !important;
        border: 0;
    }
</style>
<style scoped>
#overlay {
    margin: 0 auto;
    width: 100%;
    padding: 13px 0;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.7);
    display: flex;
    align-items: center;
    justify-content: center;
}
#overlay img {
  max-width: 40% !important;
  max-height: 30%;
}
.user_li .li_title {
  text-align: left;
  width: 9rem;
  white-space: nowrap;
  font-size: 1.4rem;
  color: #8f8383;
  height: 2.8rem;
  line-height: 2.8rem;
}
.avatar-uploader .el-upload {
    border: 1px dashed #dfdfdf;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    border: 1px solid #dfdfdf;
    color: #dfdfdf;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
    .div_title {
        height: 48px;
        border-bottom: 1px solid #DFDFDF;
    }

    .div_title .title {
        font-size: 18px;
        color: #1a1a1a;
        margin-bottom: 20px;
    }

    .div_title .title_right>button {
        height: 36px;
        border-radius: 4px;
        /* background: #DB414E; */
        color: #DB414E;
        font-size: 18px;
        border: 0;
        margin-left: 50px;
        width: 88px;
    }

    .div_title .title_right>button.state {
        color: #f1f1f1;
        background: #DB414E;
    }

    .div_title .title_right .del {
        font-size: 18px;
        color: #F24D5B;
        cursor: pointer;
    }

    .user_div .user_li {
        margin-top: 18px;
    }

    .user_div .user_li .li_title {
        text-align: right;
        width: 120px;
        margin-right: 10px;
        font-size: 16px;
        color: #333;
    }

    .user_div .user_li .li_text {
        font-size: 16px;
        color: #333;
        flex: 1;
    }

    .radio_li .gou_li {
        margin: 0 10px;
    }

    .radio_li .gou_li>i {
        width: 12px;
        margin-right: 6px;
    }

    input {
        border-color: #DCDFE6;
    }

    input:focus,
    select:focus {
        border: 1px solid #DCDFE6 !important;
    }

    .el-select {
        width: 160px;
    }
</style>



// WEBPACK FOOTER //
// src/components/pc_viwe/my_personal.vue